import React, { useState } from "react";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import { MdDescription } from "react-icons/md";

export default function HippaReleasePrivacy() {
  const [hovered, setHovered] = useState("t&c");

  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onClick: () => {},
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "Terms & Conditions",
      active: hovered === "t&c" || hovered === null,
      onClick: () => {},
      onMouseEnter: () => setHovered("t&c"),
      onMouseLeave: () => setHovered("t&c"),
    },
  ];

  const termsSections = [
    {
      title: "Patient Rights and Acknowledgments",
      desc: "By signing below, I understand:",
      items: [
        "I have the right to revoke this authorization at any time by sending written notice to VeriMED.",
        "Revoking this authorization will not affect any disclosures made before my written revocation.",
        "VeriMED will not condition care on whether I sign this authorization.",
        "The information disclosed may be subject to re-disclosure by the recipient and may no longer be protected by law.",
      ],
    },
  ];

  return (
    <div className="terms_container">
      <Header />

      <div className="terms_content">
        <div className="terms_header">
          <p>VeriMED - HIPAA Release & Privacy Statement</p>
          <p>11 December, 2025</p>
        </div>

        {termsSections.map((section, index) => (
          <div key={index} className="terms_section">
            <h2 className="terms_section_title">{section.title}</h2>

            {section.desc && (
              <p className="terms_section_desc">{section.desc}</p>
            )}

            {section.items && (
              <ul className="terms_section_list">
                {section.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
}
